<template>
  <div id="app" class="full-sc">
    <top-bar />

    <transition name="fade" mode="out-in">
      <router-view class="site-content"></router-view>
    </transition>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
  import TopBar from 'components/TopBar'
  import { init8Digits } from '@/vendors/8digits'

  export default {
    name: 'app',

    mounted () {
      this.$store.dispatch('updateRoute')
      this.$store.dispatch('createFlow/getCategories') // prefetch
      this.$nextTick(_ => {
        init8Digits()
      })
    },

    components: {
      TopBar
    }
  }
</script>

<style src="./scss/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?7163ca57